import { Card } from "../../../components/shadcn-ui/card";
import { LeadDetailsShimmer } from "./LeadDetailsShimmer";

export const LeadDetails = ({ isLoading, lead }: any) => {
  if (isLoading) {
    return <LeadDetailsShimmer />;
  }

  const {
    firstName,
    lastName,
    phoneNumber: mobileNumber,
    email: emailAddress,
    source,
    address = {},
    loanRequirementDetails,
  } = lead || {};

  return (
    <Card className="p-5 md:p-8">
      <div className="flex flex-col flex-wrap justify-between md:flex-row">
        <div>
          <div className="flex basis-1/4 items-center mb-2">
            <strong className="block mr-2 min-w-5">First Name:</strong>
            <span className="text-sm text-gray-500 font-medium">
              {firstName}
            </span>
          </div>

          <div className="flex basis-1/4 items-center mb-2">
            <strong className="block mr-2 min-w-5">Last Name:</strong>
            <span className="text-sm text-gray-500 font-medium">
              {lastName}
            </span>
          </div>
          <div className="flex basis-1/4 items-center mb-2">
            <strong className="block mr-2 min-w-5">Email:</strong>
            <span className="text-sm text-gray-500 font-medium">
              {emailAddress}
            </span>
          </div>
        </div>

        <div>
          <div className="flex basis-1/4 items-center mb-2">
            <strong className="block mr-2 min-w-5">Channel:</strong>
            <span className="text-sm text-gray-500 font-medium">
              {source?.channel}
            </span>
          </div>
          <div className="flex basis-1/4 items-center mb-2">
            <strong className="block mr-2 min-w-5">City</strong>
            <span className="text-sm text-gray-500">{address?.city}</span>
          </div>

          <div className="flex basis-1/4 items-center mb-2 flex-wrap">
            <strong className="block mr-2 min-w-5">State:</strong>
            <span className="text-sm text-gray-500 font-medium">
              {address?.state}
            </span>
          </div>
        </div>

        <div>
          {address.addressLineOne && (
            <div className="flex basis-1/4 items-center mb-2">
              <strong className="block mr-2 min-w-5">Address LineOne:</strong>
              <span className="text-sm text-gray-500">
                {address?.addressLineOne}
              </span>
            </div>
          )}
          {address.addressLineTwo && (
            <div className="flex basis-1/4 items-center mb-2">
              <strong className="block mr-2 min-w-5">Address LineOne:</strong>
              <span className="text-sm text-gray-500">
                {address?.addressLineTwo}
              </span>
            </div>
          )}
          {address.postalCode && (
            <div className="flex basis-1/4 items-center mb-2">
              <strong className="block mr-2 min-w-5">Postal Code:</strong>
              <span className="text-sm text-gray-500">
                {address?.postalCode}
              </span>
            </div>
          )}
        </div>

        <div>
          <div className="flex basis-1/4 items-center mb-2">
            <strong className="block mr-2 min-w-5">Phone Number:</strong>
            <span className="text-sm text-gray-500">{mobileNumber}</span>
          </div>
        </div>

        <div>
          <div className="flex basis-1/4 items-center mb-2">
            <strong className="block mr-2 min-w-5">Rate of interest:</strong>
            <span className="text-sm text-gray-500">
              {loanRequirementDetails?.mobileNumber}
            </span>
          </div>

          <div className="flex basis-1/4 items-center mb-2 flex-wrap">
            <strong className="block mr-2 min-w-5">Loan Amount:</strong>
            <span className="text-sm text-gray-500 font-medium">
              {loanRequirementDetails?.amount}
            </span>
          </div>

          <div className="flex basis-1/4 items-center mb-2 flex-wrap">
            <strong className="block mr-2 min-w-5">Tenure in month:</strong>
            <span className="text-sm text-gray-500 font-medium">
              {loanRequirementDetails?.tenureInMonths}
            </span>
          </div>

          <div className="flex basis-1/4 items-center mb-2 flex-wrap">
            <strong className="block mr-2 min-w-5">
              Relationship Officer(Refferrer):
            </strong>
            <span className="text-sm text-gray-500 font-medium">
              {source?.referral}
            </span>
          </div>
        </div>
      </div>
    </Card>
  );
};
